import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Login } from "./Pages/Login";
import { Route, Routes } from "react-router-dom";
import { RecuperarPassword } from "./Pages/RecuperarPassword";
import { Registro } from "./Pages/Registro";
import { UsuariosDelSistema } from "./Pages/UsuariosDelSistema";
import { MiCuenta } from "./Pages/MiCuenta";
import { UsuarioInformacion } from "./Pages/UsuarioInformacion";
import { Roles } from "./Pages/Roles";
import { RolEditar } from "./Pages/RolEditar";
import { RolAgregar } from "./Pages/RolAgregar";
import { RolAsignar } from "./Pages/RolAsignar";
import { TipoDeEje } from "./Pages/TipoDeEje";
import { TipoDeEjeAgregar } from "./Pages/TipoDeEjeAgregar";
import { TipoDeEjeDetalle } from "./Pages/TipoDeEjeDetalle";
import { Ejes } from "./Pages/Eje";
import { EjeAgregar } from "./Pages/EjeAgregar";
import { EjeEditar } from "./Pages/EjeEditar";
import { Productos } from "./Pages/Productos";
import { ProductoAgregar } from "./Pages/ProductoAgregar";
import { ProductoDetalle } from "./Pages/ProductoDetalle";
import { SubProductoAgregar } from "./Pages/SubProductoAgregar";
import { SubProductos } from "./Pages/SubProductos";
import { SubProductoEditar } from "./Pages/SubProductoEditar";
import { Categoria } from "./Pages/Categoria";
import { CategoriaAgregar } from "./Pages/CategoriaAgregar";
import { Unidades } from "./Pages/Unidades";
import { UnidadAgregar } from "./Pages/UnidadAgregar";
import { UnidadEditar } from "./Pages/UnidadEditar";
import { UPSE1 } from "./Pages/UPSE1";
import { UPSE1Agregar } from "./Pages/UPSE1Agregar";
import { ActividadAgregar } from "./Pages/ActividadAgregar";
import { SeguimientoAgregar } from "./Pages/SeguimientoAgregar";
import { Seguimientos } from "./Pages/Seguimientos";
import { RptDepartamentalMenu } from "./Pages/RptDepartamentalMenu";
import { RptDepartamento } from "./Pages/RptDepartamento";
import { RptProductosMenu } from "./Pages/RptProductosMenu";
import { RptPresupuestoMenu } from "./Pages/RptPresupuestoMenu";
import { RptProductos } from "./Pages/RptProductos";
import { RptPresupuesto } from "./Pages/RptPresupuesto";
import { ActividadEditar } from "./Pages/ActividadEditar";
import { SeguimientoEditar } from "./Pages/SeguimientoEditar";
import { UPSEBuscador } from "./Pages/UPSEBuscador";
import { UPSE1Editar } from "./Pages/UPSE1Editar";
import { UsuarioVerificar } from "./Pages/UsuarioVerificar";
import { Homepage } from "./Pages/Homepage";
import { NotificationsPage } from "./Pages/Notificacion";
import { UPSE2 } from "./Pages/UPSE2";
import { UPSE2Agregar } from "./Pages/UPSE2Agregar";
import { UPSE2Detalle } from "./Pages/UPSE2Detalle";
import { UPSE4Agregar } from "./Pages/UPSE4Agregar";
import { UPSE4 } from "./Pages/UPSE4";
import { UPSE4Detalle } from "./Pages/UPSE4Detalle";
import { UPSE4MesesPorUpse2 } from "./Pages/UPSE4MesesPorUpse2";
import { UPSE4Pendientes } from "./Pages/UPSE4Pendientes";
import { UPSE4ReporteBrecha } from "./Pages/UPSE4ReporteBrecha";
import { UPSE8Agregar } from "./Pages/UPSE8Agregar";
import { UPSE8 } from "./Pages/UPSE8";
import { UPSE8Detalle } from "./Pages/UPSE8Detalle";
import { UPSE8Configuracion } from "./Pages/UPSE8Configuracion";
import { GraficoCumplimiento } from "./Pages/RptCumplimiento";
import { GraficoCumplimiento2 } from "./Pages/RptCumplimiento2";
import { Cultivos } from "./Pages/Cultivos";
import { CultivoAgregar } from "./Pages/CultivoAgregar";
import { CultivoEditar } from "./Pages/CultivoEditar";
import { Cultivar } from "./Pages/Cultivar";
import { CultivarAgregar } from "./Pages/CultivarAgregar";
import { CultivarEditar } from "./Pages/CultivarEditar";
import { Localidades } from "./Pages/Localidades";
import { InstruccionesFormulario } from "./Pages/InstruccionesFormulario";
import { CategoriasBeneficiario } from "./Pages/CategoriasBeneficiario";

import { AuthProvider, useAuth } from "./Components/AuthContext";
import { AppBarComponent } from "./Components/AppBar";
import { useEffect } from "react";
import {
  config,
  functions,
  theme,
  validateFunction,
} from "./Components/config";
import { CategoriaDetalle } from "./Pages/CategoriaDetalle";
import { ErrorUnathorized } from "./Pages/ErrorUnathorized";
import { ThemeProvider } from "@emotion/react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Actividad } from "./Pages/Actividad";
import { UsuarioRecovery } from "./Pages/UsuarioRecovery";
import { ErrorBoundary } from "./Components/ErrorBoundary";
function App() {
  const { user, setUser, login } = useAuth();
  useEffect(() => {
    // Intenta recuperar datos de sesión desde el almacenamiento local
    const user_image = localStorage.getItem(config.user_image);
    const userId = localStorage.getItem(config.user_id);
    const user_correo = localStorage.getItem(config.user_correo);
    const user_nombre = localStorage.getItem(config.user_nombre);
    const user_apellido = localStorage.getItem(config.user_apellido);
    const funciones = localStorage.getItem(config.funciones);

    if (
      user_image &&
      userId &&
      user_correo &&
      user_nombre &&
      user_apellido &&
      funciones
    ) {
      // Si hay datos en el almacenamiento local, establece el usuario en el contexto
      login({
        fotografia: user_image,
        id: userId,
        correo: user_correo,
        nombre: user_nombre,
        apellido: user_apellido,
        funciones: funciones,
      });
    }
  }, [setUser]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <BrowserRouter>
          {user && <AppBarComponent />}
          <Routes>
            {!user ? (
              <>
                <Route path="/*" element={<Login />} />
                <Route path="/Login" element={<Login />} />
                <Route
                  path="/RecuperarPassword"
                  element={<RecuperarPassword />}
                />
                <Route path="/Registro" element={<Registro />} />
                <Route path="/Verify" element={<UsuarioVerificar />} />
                <Route path="/Recovery" element={<UsuarioRecovery />} />
              </>
            ) : (
              <>
                <Route
                  path="/*"
                  element={
                    <ErrorBoundary>
                      <Homepage />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/Homepage"
                  element={
                    <ErrorBoundary>
                      <Homepage />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/UsuariosDelSistema"
                  element={
                    <ErrorBoundary>
                      <UsuariosDelSistema />
                    </ErrorBoundary>
                  }
                />
                <Route path="/MiCuenta" element={<MiCuenta />} />
                <Route path="/Localidades" element={<ErrorBoundary><Localidades /></ErrorBoundary>} />
                <Route
                  path="/InstruccionesFormulario"
                  element={
                    validateFunction(user, functions.ManageInstrucciones) ? (
                      <ErrorBoundary>
                        <InstruccionesFormulario />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/CategoriasBeneficiario"
                  element={
                    validateFunction(user, functions.ManageCategoriaBeneficiario) ? (
                      <ErrorBoundary>
                        <CategoriasBeneficiario />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UsuarioInformacion"
                  element={<UsuarioInformacion />}
                />
                <Route
                  path="/Roles"
                  element={
                    validateFunction(
                      user,
                      functions.ManageRolesAndFunctions
                    ) ? (
                      <ErrorBoundary>
                        <Roles />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/RolEditar"
                  element={
                    validateFunction(
                      user,
                      functions.ManageRolesAndFunctions
                    ) ? (
                      <ErrorBoundary>
                        <RolEditar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/RolAgregar"
                  element={
                    validateFunction(
                      user,
                      functions.ManageRolesAndFunctions
                    ) ? (
                      <ErrorBoundary>
                        <RolAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/RolAsignar"
                  element={
                    validateFunction(
                      user,
                      functions.ManageRolesAndFunctions
                    ) ? (
                      <ErrorBoundary>
                        <RolAsignar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route path="/TipoDeEje" element={<TipoDeEje />} />
                <Route
                  path="/TipoDeEjeDetalle"
                  element={
                    <ErrorBoundary>
                      <TipoDeEjeDetalle />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/TipoDeEjeAgregar"
                  element={
                    validateFunction(user, functions.CreateTipoDeEje) ? (
                      <ErrorBoundary>
                        <TipoDeEjeAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route path="/Ejes" element={<Ejes />} />
                <Route
                  path="/EjeAgregar"
                  element={
                    validateFunction(user, functions.CreateEje) ? (
                      <ErrorBoundary>
                        <EjeAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/EjeEditar"
                  element={
                    validateFunction(user, functions.ModifyEje) ? (
                      <ErrorBoundary>
                        <EjeEditar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route path="/Productos" element={<Productos />} />
                <Route
                  path="/ProductoAgregar"
                  element={
                    validateFunction(user, functions.CreateCatalog) ? (
                      <ErrorBoundary>
                        <ProductoAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/ProductoDetalle"
                  element={
                    <ErrorBoundary>
                      <ProductoDetalle />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/SubProductos"
                  element={
                    <ErrorBoundary>
                      <SubProductos />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/SubProductoAgregar"
                  element={
                    validateFunction(user, functions.CreateProduct) ? (
                      <ErrorBoundary>
                        <SubProductoAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/SubProductoEditar"
                  element={
                    validateFunction(user, functions.ModifyProduct) ? (
                      <ErrorBoundary>
                        <SubProductoEditar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />

                <Route path="/Cultivos" element={<Cultivos />} />
                <Route
                  path="/CultivoAgregar"
                  element={
                    validateFunction(user, functions.CreateCategory) ? (
                      <ErrorBoundary>
                        <CultivoAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/CultivoEditar"
                  element={
                    validateFunction(user, functions.CreateCategory) ? (
                      <ErrorBoundary>
                        <CultivoEditar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />

                <Route path="/Cultivar" element={<Cultivar />} />
                <Route
                  path="/CultivarAgregar"
                  element={
                    validateFunction(user, functions.CreateCategory) ? (
                      <ErrorBoundary>
                        <CultivarAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/CultivarEditar"
                  element={
                    validateFunction(user, functions.CreateCategory) ? (
                      <ErrorBoundary>
                        <CultivarEditar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />

                <Route
                  path="/Categoria"
                  element={
                    <ErrorBoundary>
                      <Categoria />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/CategoriaDetalle"
                  element={
                    <ErrorBoundary>
                      <CategoriaDetalle />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/CategoriaAgregar"
                  element={
                    validateFunction(user, functions.CreateCategory) ? (
                      <ErrorBoundary>
                        <CategoriaAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/Unidades"
                  element={
                    <ErrorBoundary>
                      <Unidades />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/UnidadAgregar"
                  element={
                    validateFunction(user, functions.CreateUnit) ? (
                      <ErrorBoundary>
                        <UnidadAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UnidadEditar"
                  element={
                    validateFunction(user, functions.ModifyUnit) ? (
                      <ErrorBoundary>
                        <UnidadEditar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE1"
                  element={
                    <ErrorBoundary>
                      <UPSE1 />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/UPSE1Agregar"
                  element={
                    validateFunction(user, functions.CreateUPSE) ? (
                      <ErrorBoundary>
                        <UPSE1Agregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE1Editar"
                  element={
                    validateFunction(user, functions.ModifyUPSE) ? (
                      <ErrorBoundary>
                        <UPSE1Editar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSEBuscador"
                  element={
                    <ErrorBoundary>
                      <UPSEBuscador />
                    </ErrorBoundary>
                  }
                />
                <Route path="/Actividad" element={<Actividad />} />
                <Route
                  path="/ActividadAgregar"
                  element={
                    validateFunction(user, functions.CreateActivity) ? (
                      <ErrorBoundary>
                        <ActividadAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/ActividadEditar"
                  element={
                    validateFunction(user, functions.ModifyActivity) ? (
                      <ErrorBoundary>
                        <ActividadEditar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/SeguimientoAgregar"
                  element={
                    validateFunction(user, functions.CreateSeguimiento) ? (
                      <ErrorBoundary>
                        <SeguimientoAgregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/Seguimientos"
                  element={
                    <ErrorBoundary>
                      <Seguimientos />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/SeguimientoEditar"
                  element={
                    validateFunction(user, functions.ModifySeguimiento) ? (
                      <ErrorBoundary>
                        <SeguimientoEditar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/RptDepartamentalMenu"
                  element={
                    <ErrorBoundary>
                      <RptDepartamentalMenu />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/RptDepartamento"
                  element={
                    <ErrorBoundary>
                      <RptDepartamento />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/RptProductosMenu"
                  element={
                    <ErrorBoundary>
                      <RptProductosMenu />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/RptProductos"
                  element={
                    <ErrorBoundary>
                      <RptProductos />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/RptPresupuestoMenu"
                  element={
                    <ErrorBoundary>
                      <RptPresupuestoMenu />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/RptPresupuesto"
                  element={
                    <ErrorBoundary>
                      <RptPresupuesto />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/Notificaciones"
                  element={
                    <ErrorBoundary>
                      <NotificationsPage />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/UPSE2"
                  element={
                    validateFunction(user, functions.ViewUPSE2) ? (
                      <ErrorBoundary>
                        <UPSE2 />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE2Agregar"
                  element={
                    validateFunction(user, functions.CreateUPSE2) ? (
                      <ErrorBoundary>
                        <UPSE2Agregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE2Detalle"
                  element={
                    validateFunction(user, functions.ViewUPSE2) ? (
                      <ErrorBoundary>
                        <UPSE2Detalle />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE4Agregar"
                  element={
                    validateFunction(user, functions.CreateUPSE4) ? (
                      <ErrorBoundary>
                        <UPSE4Agregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE4"
                  element={
                    validateFunction(user, functions.ViewUPSE4) ? (
                      <ErrorBoundary>
                        <UPSE4 />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE4Detalle"
                  element={
                    validateFunction(user, functions.ViewUPSE4) ? (
                      <ErrorBoundary>
                        <UPSE4Detalle />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE4MesesPorUpse2"
                  element={
                    validateFunction(user, functions.ViewUPSE4) ? (
                      <ErrorBoundary>
                        <UPSE4MesesPorUpse2 />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE4Pendientes"
                  element={
                    validateFunction(user, functions.ReviewUPSE4) ? (
                      <ErrorBoundary>
                        <UPSE4Pendientes />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE4ReporteBrecha"
                  element={
                    validateFunction(user, functions.ViewUPSE4) ? (
                      <ErrorBoundary>
                        <UPSE4ReporteBrecha />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE8Agregar"
                  element={
                    validateFunction(user, functions.CreateUPSE8) ? (
                      <ErrorBoundary>
                        <UPSE8Agregar />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE8"
                  element={
                    validateFunction(user, functions.ViewUPSE8) ? (
                      <ErrorBoundary>
                        <UPSE8 />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE8Detalle"
                  element={
                    validateFunction(user, functions.ViewUPSE8) ? (
                      <ErrorBoundary>
                        <UPSE8Detalle />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/UPSE8Configuracion"
                  element={
                    validateFunction(user, functions.ManageUPSE8Configuracion) ? (
                      <ErrorBoundary>
                        <UPSE8Configuracion />
                      </ErrorBoundary>
                    ) : (
                      <ErrorUnathorized />
                    )
                  }
                />
                <Route
                  path="/RptCumplimientos"
                  element={
                    <ErrorBoundary>
                      <GraficoCumplimiento />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/RptCumplimientos2"
                  element={
                    <ErrorBoundary>
                      <GraficoCumplimiento2 />
                    </ErrorBoundary>
                  }
                />
              </>
            )}
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default () => (
  <AuthProvider>
    <App />
  </AuthProvider>
);
